/**
 * data-testid registry for the Kellermann Reid landing experience.
 */
export const LANDING = {
  logo: "kr-logo",
  navbar: "kr-navbar",
  navLinkPrefix: "kr-nav-",
  navDropdownPrefix: "kr-nav-dropdown-",
  requestAccessNav: "kr-nav-request-access",
  mobileNavToggle: "kr-mobile-nav-toggle",

  hero: "kr-hero",
  heroHeadline: "kr-hero-headline",
  heroSub: "kr-hero-sub",
  heroCtaPrimary: "kr-hero-cta-primary",
  heroCtaSecondary: "kr-hero-cta-secondary",

  platformPosture: "kr-platform-posture",

  platformOverview: "kr-platform-overview",
  strategies: "kr-strategies",
  strategyCardPrefix: "kr-strategy-",
  viewAllStrategies: "kr-strategies-view-all",
  creditBridge: "kr-credit-bridge",
  industrialEquity: "kr-industrial-equity",
  whyNow: "kr-why-now",
  downsideProtection: "kr-downside-protection",

  fundArchitecture: "kr-fund-architecture",
  fundArchitectureExplore: "kr-fund-architecture-explore",
  fundArchitectureFormation: "kr-fund-architecture-formation",
  fundVehiclePrefix: "kr-fund-vehicle-",

  perspectives: "kr-perspectives",
  perspectivesAll: "kr-perspectives-all",
  perspectiveCardPrefix: "kr-perspective-",

  partnerEmailPrefix: "kr-partner-email-",
  partnerLinkedinPrefix: "kr-partner-linkedin-",
  partnerContactBtnPrefix: "kr-partner-contact-btn-",
  partnerLinkedinBtnPrefix: "kr-partner-linkedin-btn-",
  partnerProfileBtnPrefix: "kr-partner-profile-btn-",

  partnership: "kr-partnership",
  partnershipCardPrefix: "kr-partnership-card-",
  partnershipFounderPrefix: "kr-partnership-founder-",
  partnershipMeetPartnership: "kr-partnership-meet",

  stewardship: "kr-stewardship",

  anchorPartner: "kr-anchor-partner",
  initiateDialogue: "kr-initiate-dialogue",
  governance: "kr-governance",

  newsroom: "kr-newsroom",
  newsroomItemPrefix: "kr-newsroom-",
  newsroomMedia: "kr-newsroom-media",

  offices: "kr-offices",
  officeCardPrefix: "kr-office-",

  serviceProviders: "kr-service-providers",
  platformInfraIntro: "kr-platform-infra-intro",
  platformInfraDisclaimer: "kr-platform-infra-disclaimer",
  platformInfraCardPrefix: "kr-platform-infra-card-",
  platformInfraLinkPrefix: "kr-platform-infra-link-",

  investorAccess: "kr-investor-access",
  investorRequestAccess: "kr-investor-request-access",
  investorGeneralEnquiry: "kr-investor-general-enquiry",
  investorStrategic: "kr-investor-strategic",

  contact: "kr-contact",
  contactForm: "kr-contact-form",
  contactName: "kr-contact-name",
  contactEmail: "kr-contact-email",
  contactFirm: "kr-contact-firm",
  contactSubject: "kr-contact-subject",
  contactMessage: "kr-contact-message",
  contactSubmit: "kr-contact-submit",
  contactStatus: "kr-contact-status",
  contactEmailLink: "kr-contact-email-link",
  contactIrLink: "kr-contact-ir-link",

  footer: "kr-footer",
  footerLogo: "kr-footer-logo",
  footerBrandSeal: "kr-footer-brand-seal",
  footerLegal: "kr-footer-legal",
  footerPrivacy: "kr-footer-privacy",
  footerCookies: "kr-footer-cookies",
  footerCorrespondence: "kr-footer-correspondence",

  strategiesPage: "kr-strategies-page",
  strategiesPageCardPrefix: "kr-strategies-page-card-",
  strategiesPageRequest: "kr-strategies-page-request",
  strategiesPagePathwaysBridge: "kr-strategies-page-pathways-bridge",

  perspectivesPage: "kr-perspectives-page",
  perspectivesPagePaperPrefix: "kr-perspectives-page-paper-",
  perspectivesPageRequest: "kr-perspectives-page-request",

  partnershipPage: "kr-partnership-page",
  partnershipPageRolePrefix: "kr-partnership-page-role-",
  partnershipPagePartnerPrefix: "kr-partnership-page-partner-",
  partnershipPagePortraitPrefix: "kr-partnership-page-portrait-",
  partnershipPageFounders: "kr-partnership-page-founders",
  partnershipPageReserved: "kr-partnership-page-reserved",
  partnershipPageDisclosure: "kr-partnership-page-disclosure",
  partnershipPageRequest: "kr-partnership-page-request",

  legalPage: "kr-legal-page",
  privacyPage: "kr-privacy-page",
  cookiesPage: "kr-cookies-page",

  // Sub-page: Funds detail (/funds)
  fundsPage: "kr-funds-page",
  fundsPageFamilyPrefix: "kr-funds-page-family-",
  fundsPageVehiclePrefix: "kr-funds-page-vehicle-",
  fundsPageRequest: "kr-funds-page-request",

  // Sub-page: Strategy detail (/strategies/<slug>)
  strategyDetailPage: "kr-strategy-detail-page",
  strategyDetailRequest: "kr-strategy-detail-request",
  strategyDetailNext: "kr-strategy-detail-next",

  // Sub-page: Team (/team)
  teamPage: "kr-team-page",
  teamPagePartnerPrefix: "kr-team-page-partner-",
  teamPageReservedPrefix: "kr-team-page-reserved-",
  teamPageNetworkPrefix: "kr-team-page-network-",
  teamPageRequest: "kr-team-page-request",

  // Sub-page: Contact (/contact)
  contactPage: "kr-contact-page",
  contactPageForm: "kr-contact-page-form",
  contactPageName: "kr-contact-page-name",
  contactPageEmail: "kr-contact-page-email",
  contactPageFirm: "kr-contact-page-firm",
  contactPageSubject: "kr-contact-page-subject",
  contactPageMessage: "kr-contact-page-message",
  contactPageSubmit: "kr-contact-page-submit",
  contactPageStatus: "kr-contact-page-status",
  contactPageOfficePrefix: "kr-contact-page-office-",

  // Sub-page: Responsible Capital (/responsible-capital)
  responsibleCapitalPage: "kr-responsible-capital-page",
  responsibleCapitalCommitmentPrefix: "kr-responsible-capital-commitment-",
  responsibleCapitalRequest: "kr-responsible-capital-request",

  // Sub-page: Newsroom (/news)
  newsPage: "kr-news-page",
  newsPageItemPrefix: "kr-news-page-item-",
  newsPageMedia: "kr-news-page-media",
  newsPageItemLinkPrefix: "kr-news-page-link-",
  newsroomItemLinkPrefix: "kr-newsroom-link-",

  // Sub-page: Newsroom detail (/news/:slug)
  newsDetailPage: "kr-news-detail-page",
  newsDetailBody: "kr-news-detail-body",
  newsDetailShare: "kr-news-detail-share",
  newsDetailShareCopy: "kr-news-detail-share-copy",
  newsDetailShareLinkedin: "kr-news-detail-share-linkedin",
  newsDetailShareWhatsapp: "kr-news-detail-share-whatsapp",
  newsDetailShareEmail: "kr-news-detail-share-email",
  newsDetailBack: "kr-news-detail-back",
  newsDetailRelatedPrefix: "kr-news-detail-related-",
  newsDetailNewer: "kr-news-detail-newer",
  newsDetailOlder: "kr-news-detail-older",
  newsDetailMedia: "kr-news-detail-media",

  // Footer nav additions
  footerFunds: "kr-footer-funds",
  footerTeam: "kr-footer-team",
  footerContact: "kr-footer-contact",
  footerResponsible: "kr-footer-responsible",
  footerNews: "kr-footer-news",

  // Sub-page: Perspective detail (/perspectives/:slug)
  perspectiveDetailPage: "kr-perspective-detail-page",
  perspectiveDetailRequest: "kr-perspective-detail-request",
  perspectiveDetailNext: "kr-perspective-detail-next",

  // Sub-page: Press Kit (/press-kit)
  pressKitPage: "kr-press-kit-page",
  pressKitAssetPrefix: "kr-press-kit-asset-",
  pressKitFactPrefix: "kr-press-kit-fact-",
  pressKitContact: "kr-press-kit-contact",

  // Sub-page: Careers (/careers)
  careersPage: "kr-careers-page",
  careersInterest: "kr-careers-interest",

  // Sub-page: Disclosures (/disclosures)
  disclosuresPage: "kr-disclosures-page",
  disclosuresSectionPrefix: "kr-disclosures-section-",

  // Sub-page: Not Found (404)
  notFoundPage: "kr-not-found-page",
  notFoundHome: "kr-not-found-home",

  // Footer additions
  footerPressKit: "kr-footer-press-kit",
  footerCareers: "kr-footer-careers",
  footerDisclosures: "kr-footer-disclosures",

  // Selective Capital Pathways (homepage section)
  capitalPathways: "kr-capital-pathways",
  capitalPathwaysLead: "kr-capital-pathways-lead",
  capitalPathwaysPillarPrefix: "kr-capital-pathways-pillar-",
  capitalPathwaysSubject: "kr-capital-pathways-subject",
  capitalPathwaysReadMore: "kr-capital-pathways-read-more",
  capitalPathwaysFamilyOffice: "kr-capital-pathways-family-office",
  capitalPathwaysFamilyOfficeTitle: "kr-capital-pathways-family-office-title",
  capitalPathwaysFamilyOfficeStepPrefix: "kr-capital-pathways-family-office-step-",
  capitalPathwaysFamilyOfficeCta: "kr-capital-pathways-family-office-cta",
  capitalPathwaysFamilyOfficeExplore: "kr-capital-pathways-family-office-explore",

  // Sub-page: Capital Pathways detail (/capital-pathways)
  capitalPathwaysPage: "kr-capital-pathways-page",
  capitalPathwaysPageLead: "kr-capital-pathways-page-lead",
  capitalPathwaysPagePathwayPrefix: "kr-capital-pathways-page-pathway-",
  capitalPathwaysPageStagePrefix: "kr-capital-pathways-page-stage-",
  capitalPathwaysPageSubjectList: "kr-capital-pathways-page-subject-list",
  capitalPathwaysPageRequest: "kr-capital-pathways-page-request",
  capitalPathwaysPageFamilyOfficeLink: "kr-capital-pathways-page-family-office-link",

  // Sub-page: Family Office Investment Solutions (/family-office-investment-solutions)
  familyOfficePage: "kr-family-office-page",
  familyOfficeIntro: "kr-family-office-intro",
  familyOfficeProcess: "kr-family-office-process",
  familyOfficeStagePrefix: "kr-family-office-stage-",
  familyOfficeCapabilities: "kr-family-office-capabilities",
  familyOfficeCapabilityPrefix: "kr-family-office-capability-",
  familyOfficeGlobal: "kr-family-office-global",
  familyOfficeCoverage: "kr-family-office-coverage",
  familyOfficeFootprintLink: "kr-family-office-footprint-link",
  familyOfficeControl: "kr-family-office-control",
  familyOfficePathwaysLink: "kr-family-office-pathways-link",
  familyOfficeDisclosuresLink: "kr-family-office-disclosures-link",
  familyOfficeCta: "kr-family-office-cta",
  footerCapitalPathways: "kr-footer-capital-pathways",

  cookieBanner: "kr-cookie-banner",
  cookieAccept: "kr-cookie-accept",
  cookieDecline: "kr-cookie-decline",
  cookieLearnMore: "kr-cookie-learn-more",

  modalRoot: "kr-modal-root",
  modalBackdrop: "kr-modal-backdrop",
  modalDialog: "kr-modal-dialog",
  modalHeading: "kr-modal-heading",
  modalIntro: "kr-modal-intro",
  modalClose: "kr-modal-close",
  modalForm: "kr-modal-form",
  modalName: "kr-modal-name",
  modalEmail: "kr-modal-email",
  modalFirm: "kr-modal-firm",
  modalRole: "kr-modal-role",
  modalNotes: "kr-modal-notes",
  modalSubmit: "kr-modal-submit",
  modalStatus: "kr-modal-status",
  modalInterestPrefix: "kr-modal-interest-",
};
